import {Breakpoints, useIsMobile} from '@vw-marketing/us-components';
import React, {ForwardedRef} from 'react';
import {useTrackingManager} from '../../hooks/use-tracking-manager';
import {onVWBasicAccordionClick} from '../../tagging/tagging-helpers';
import {UsedVehicle} from '../../typing/used-inventory';
import {clearText} from '../../utils/general';
import ChevronArrow from '../icons/chevron-arrow';
import {
  ShowMoreTextWrapper,
  StyledButtonText,
  StyledDescription,
  StyledFadedBox,
  StyledHypen,
  StyledList,
  StyledListItem,
  StyledShowMoreButton,
  StyledShowMoreButtonWrapper,
} from './styles';

interface ShowMoreTextProps {
  readonly items?: string[];
  readonly vehicleData?: UsedVehicle;
}

const ShowMoreText = React.forwardRef(
  (props: ShowMoreTextProps, ref: ForwardedRef<HTMLDivElement>) => {
    let {items, vehicleData} = props;
    const isMobile = useIsMobile(Breakpoints.b560);
    const [showMore, setShowMore] = React.useState(false);
    const maxItemsToShow = isMobile ? 4 : 6;
    const displayShowButton = items && items?.length >= maxItemsToShow;
    const bullets = showMore ? items : items?.slice(0, maxItemsToShow);
    const bulletsMarkup =
      bullets &&
      bullets?.map((bullet, index) => {
        return (
          <StyledListItem className="key-features__item" key={index}>
            <StyledHypen />
            <span>{clearText(bullet)}</span>
          </StyledListItem>
        );
      });
    const trackingManager = useTrackingManager();

    const handleOnClick = () => {
      trackingManager &&
        onVWBasicAccordionClick(
          {
            accordingOpen: !showMore,
            linkUrl: window.location.href,
            filterName: !showMore ? 'View More' : 'View Less',
          },
          trackingManager,
          vehicleData,
        );

      setShowMore(!showMore);
      if (showMore) {
        if (ref != null && typeof ref !== 'function') {
          ref?.current?.scrollIntoView({behavior: 'auto'});
        }
      }
    };

    return displayShowButton ? (
      <ShowMoreTextWrapper ref={ref} className="show-more-items-wrapper">
        <StyledDescription className="description-items">
          <StyledList className="key-features__list">
            {bulletsMarkup}
          </StyledList>
          {!showMore && displayShowButton && <StyledFadedBox />}
        </StyledDescription>

        <StyledShowMoreButtonWrapper className="show-more-button-wrapper">
          <StyledShowMoreButton
            className="show-more-button"
            onClick={handleOnClick}
          >
            <ChevronArrow rotateDegrees={!showMore ? '0' : '180'} />
            <StyledButtonText className="show-more-button-items">
              {!showMore ? 'View More' : 'View Less'}
            </StyledButtonText>
          </StyledShowMoreButton>
        </StyledShowMoreButtonWrapper>
      </ShowMoreTextWrapper>
    ) : (
      <ShowMoreTextWrapper ref={ref} className="show-more-items-wrapper">
        <StyledDescription className="description-items">
          <div>{bulletsMarkup}</div>
        </StyledDescription>
      </ShowMoreTextWrapper>
    );
  },
);

export default ShowMoreText;
